// import { includes } from "lodash";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
// import { getUser } from "../../../services/authService";
import TableColumnOrder from "../TableColumnOrder";
import { filter } from "lodash";
import Tooltips from "../../Custom Components/tooltip";

function DepartureReportActionCenter({
	date,
	setDate,
	dataExportHandler,
	allColumns,
	getToggleHideAllColumnsProps,
	filteredUserAccessData,
}) {
	const [modalShow, setModalShow] = useState(false);
	var allowToDownload =
		filter(filteredUserAccessData, { DownLoad: 1 }).length > 0;

	// const user = getUser();

	return (
		<>
			{modalShow && (
				<TableColumnOrder
					allColumns={allColumns}
					getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
					show={modalShow}
					onHide={() => setModalShow(false)}
				/>
			)}
			<div className="flex-row-align-center">
				<Form.Group style={{ marginLeft: "12px" }}>
					<Form.Control
						type="date"
						className="hiden-inp"
						value={date}
						onChange={(e) => setDate(e.target.value)}
					/>
				</Form.Group>
				{/* {includes(user.role, "ata_pune") && (
          <> */}
				{allowToDownload && (
					// <Button
					// 	className="btn btn-sm btn-tbl"
					// 	onClick={() => dataExportHandler()}
					// >
					// 	<i className="bx bxs-download"></i>
					// </Button>
					<Tooltips content={"Export"} direction="down">
						<button
							type="button"
							className="tractorActionCenter__upload"
							onClick={() => dataExportHandler()}
						>
							<svg
								viewBox="0 0 512 512"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								fill="#000000"
							>
								<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
								<g
									id="SVGRepo_tracerCarrier"
									stroke-linecap="round"
									strokeLinejoin="round"
								></g>
								<g id="SVGRepo_iconCarrier">
									<g
										id="Page-1"
										stroke="none"
										strokeWidth="1"
										fill="none"
										fillRule="evenodd"
									>
										<g
											id="Combined-Shape"
											fill="#ffffff"
											transform="translate(64.000000, 48.915055)"
										>
											<path d="M170.666667,36.418278 L170.666667,79.0849447 L42.6666667,79.0849447 L42.6666667,356.418278 L341.333333,356.418278 L341.333333,228.418278 L384,228.418278 L384,399.084945 L0,399.084945 L0,36.418278 L170.666667,36.418278 Z M313.751611,0 L414.169889,100.418278 L313.751611,200.836556 L283.581722,170.666667 L332.485,121.751 L277.333333,121.751611 C243.249474,121.751611 215.388568,148.395237 213.441977,181.991125 L213.333333,185.751611 L213.333333,292.418278 L170.666667,292.418278 L170.666667,185.751611 C170.666667,128.391511 215.942543,81.6061582 272.706355,79.1834943 L277.333333,79.0849447 L332.484,79.084 L283.581722,30.1698893 L313.751611,0 Z"></path>
										</g>
									</g>
								</g>
							</svg>
						</button>
					</Tooltips>
				)}
				{/* </>
        )} */}
				{/* <Button
					className="btn btn-sm btn-tbl tableColumnFilter_btn"
					onClick={() => setModalShow(true)}
				>
					<i class="bx bx-columns tableColumnFilter"></i>
				</Button> */}
				<Tooltips content={"Column Filter"} direction="down">
					<button
						className="tableColumnFilter_btn "
						onClick={() => setModalShow(true)}
					>
						<i class="bx bx-columns tableColumnFilter"></i>
					</button>
				</Tooltips>
			</div>
		</>
	);
}

export default DepartureReportActionCenter;
